import { LaptopOutlined, NotificationOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Menu, theme, Row, Col, Modal, Button } from 'antd';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import logo from "../img/logo.png";
import React, { useState } from 'react';
import Cookies from 'universal-cookie';
 
// Este es el archivo del panel

const { Header, Content, Sider } = Layout;
const items1 = ['1', '2', '3'].map((key) => ({
  key,
  label: `nav ${key}`,
}));


function getItem(label, key, icon, children, type, ruta) {
  return {
    key,
    icon,
    children,
    label,
    type,
    ruta,
  };
}


const rootSubmenuKeys = ['sub0', 'sub1', 'sub2', 'sub3', 'sub4'];

const Panel = ({ componente  }) => {
const cookies = new Cookies();
  const nivel = cookies.get('nivel');
  const correo = cookies.get('correo');
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);

  // Mostrar modal
  const showLogoutModal = () => {
    setIsModalVisible(true);
  };

  // Confirmar logout
  const handleConfirmLogout = () => {
    localStorage.removeItem('accessToken');
    document.cookie = "sessionID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    cookies.remove('correo');
    cookies.remove('nivel');
    navigate('/');
  };

  // Cancelar modal
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();


  
  return (
    <Layout className="layout">
      <div style={{ background:'#088B7F', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link to="/inicio">
          <div className="demo-logo" style={{ display: 'flex' }}>
            <img src={logo} width="60" height="60" />
          </div>
        </Link>
      
          <p className="titulo3" style={{color: 'white', fontSize: 20.0}}>Bienvenido {correo} </p>
          <Button
          // className="titulo3" 
          onClick={showLogoutModal} 
          style={{ cursor: 'pointer', color: 'black', fontSize: 20.0}}
          >Cerrar sesión</Button><br />
   
      </div>

      <Layout>
        <Sider width={200} style={{ background: colorBgContainer }}>
          {nivel == 4 && (
            <Menu
              mode="inline"
              style={{
                height: '100%',
                borderRight: 0,
              }}
              items={[
                {
                  key: 'inicio',
                  label: 'Página principal',
                  onClick: () => navigate('/inicio'),
                }
              ]}
            />
          )}
        </Sider>

        <Layout style={{ padding: '0 24px 24px' }}>
            <Breadcrumb items={[{ title: 'Inicio' }]} />

          
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
            {componente}
          </Content>
        </Layout>
      </Layout>
      {/* Modal de confirmación */}
      <Modal
        title="Confirmar cierre de sesión"
        open={isModalVisible}
        onOk={handleConfirmLogout}
        onCancel={handleCancel}
        footer={[
        <Button key="ok" type="primary" danger onClick={handleConfirmLogout}>
          Sí, cerrar sesión
        </Button>,
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
      ]}
      >
        <p>¿Estás seguro de que deseas cerrar sesión?</p>
      </Modal>
    </Layout>
  );
};

export default Panel;
